<template>
    <div class="main">
        <div class="list-turma">

            <c-panel>

                <el-form label-position="top" class="u-mb-30">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="10" :md="10" v-if="($store.state.user.tipo > 3 && $store.state.user.tipo <= 8) || $store.state.user.tipo == 10">
                            <el-form-item key="instituicao">
                                <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="10" :md="10">
                            <el-form-item key="categoria">
                                <el-select
                                    :disabled="!filtro.instituicao.id || loadingCategorias"
                                    @change="changeCategoria"
                                    v-model="filtro.categoria_id"
                                    filterable
                                    placeholder="Selecionar Categoria">
                                    <el-option v-for="(item, i) in categorias" :key="i" :label="item.name" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col v-if="$store.state.user.tipo == 6" :xs="24" :sm="4" :md="4" class="u-text-right">
                            <el-button type="primary" @click="showDialogFormCurso()">NOVO CURSO</el-button>
                        </el-col>
                    </el-row>
                </el-form>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="hidden-mobile" style="width: 70px;">cod</th>
                                <th>Nome</th>
                                <th class="hidden-mobile u-text-center" style="width: 120px;">Abrev.</th>
                                <th class="hidden-mobile u-text-center">Visível</th>
                                <th v-if="$store.state.user.tipo == 6" style="width: 150px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody v-if="statusList">
                            <tr v-for="item in items" :key="item.id">
                                <td class="hidden-mobile">{{ item.id }}</td>
                                <td>{{ item.fullname }}</td>
                                <td class="hidden-mobile u-text-center">{{ item.shortname }}</td>
                                <td class="hidden-mobile u-text-center">{{ (item.visible) ? 'Sim' : 'Não' }}</td>
                                <td v-if="$store.state.user.tipo == 6" class="u-text-center acao">
                                    <el-button @click="deleteCurso(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-if="!statusList" class="u-text-center u-mt-25">
                        <img src="/public/img/loading-bar.gif" />
                    </div>
                </div>

                <div v-if="statusList && filtro.instituicao.id && !filtro.categoria_id && items.length === 0">
                    <h4 class="u-text-center">selecione uma categoria</h4>
                </div>

                <div v-if="statusList && filtro.instituicao.id && filtro.categoria_id && items.length === 0">
                    <h4 class="u-text-center">nenhum curso cadastrado</h4>
                </div>

                <div v-if="statusList && !filtro.instituicao.id && items.length === 0">
                    <h4 class="u-text-center">selecione uma instituição</h4>
                </div>

            </c-panel>

            <el-dialog :close-on-click-modal="false" title="NOVO CURSO" width="70%" top="5vh" :visible.sync="dialogFormCurso">
                <div class="main">
                    <el-form @submit.native.prevent="onSubmitCurso" :model="form" ref="form" label-position="top">

                        <el-row :gutter="10">
                            <el-col :xs="24">
                                <el-form-item label="Categoria" prop="categoria_id" :rules="[$requiredBlur]" key="categoria_id">
                                    <el-select
                                        v-model="form.categoria_id"
                                        filterable
                                        :disabled="!filtro.instituicao.id || loadingCategorias"
                                        placeholder="Selecionar Categoria">
                                        <el-option v-for="(item, i) in categorias" :key="i" :label="item.name" :value="item.id"> </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="6" :md="6">
                                <el-form-item label="Abreviação" prop="abreviacao" :rules="[$requiredBlur]" key="abreviacao">
                                    <el-input v-model="form.abreviacao" maxlength="191" v-on:blur="formatData('abreviacao')"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="18" :md="18">
                                <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
                                    <el-input v-model="form.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :xs="24">
                                <el-form-item class="u-text-right u-mt-15">
                                    <el-button type="primary" id="btn-modelo" native-type="submit">SALVAR</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        dialogFormCurso: false,
        statusList: true,
        loadingCategorias: false,
        filtro: {
            instituicao: {
                id: '',
                nome: ''
            },
            categoria_id: ''
        },
        categorias: [],
        items: [],
        form: {
            nome: '',
            abreviacao: '',
            categoria_id: ''
        }
    }),
    mounted(){
        if(this.$store.state.config.instituicao){
            this.filtro.instituicao = this.$store.state.config.instituicao;
        }

        this.loadCategorias();
    },
    methods: {
        async changeInstituicao(){
            if(this.$store.state.user.tipo > 3 && this.$store.state.user.tipo <= 8){
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }

            this.filtro.categoria_id = '';
            this.items = [];
            this.loadCategorias();
        },

        changeCategoria(){
            this.loadingCursos();
        },

        loadCategorias(){
            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){
                this.categorias = [];
                this.items = [];
                return false;
            }

            let i = this.$store.state.config.instituicao.id;
            this.loadingCategorias = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ava/categorias?instituicao_id=${i}`, this.$store.getters.getHeaderAuth).then(response => {
                this.categorias = response.data || [];
                this.loadingCategorias = false;

                // se já tinha categoria selecionada, recarrega cursos
                if(this.filtro.categoria_id){
                    this.loadingCursos();
                }
            }).catch((error) => {
                this.loadingCategorias = false;
                this.$store.commit('throwException', error);
            });
        },

        loadingCursos(){
            if(!this.filtro.categoria_id){
                this.items = [];
                this.statusList = true;
                return false;
            }

            this.statusList = false;
            this.items = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ava/cursos?categoria_id=${this.filtro.categoria_id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.items = (response.data && response.data.courses) ? response.data.courses : [];
                this.statusList = true;
            }).catch((error) => { this.statusList = true; this.$store.commit('throwException', error); });
        },

        showDialogFormCurso(){
            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){
                window.eventBus.$emit('alert', {msg: 'Por favor, selecione uma instituição.', type: 'warning'});
                return false;
            }

            this.form = {
                nome: '',
                abreviacao: '',
                categoria_id: this.filtro.categoria_id || ''
            };

            this.dialogFormCurso = true
        },

        onSubmitCurso(){
            this.$refs.form.validate((valid) =>{ if(valid){

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ava/curso`, {
                    nome: this.form.nome,
                    abreviacao: this.form.abreviacao,
                    categoria_id: this.form.categoria_id
                }, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                    this.dialogFormCurso = false

                    // seleciona a categoria do cadastro, se mudou
                    this.filtro.categoria_id = this.form.categoria_id;
                    this.loadingCursos();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },

        deleteCurso(id){
            this.$msgbox.confirm('Tem certeza que deseja excluir este curso?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/ava/curso/${id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingCursos();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },

        formatData(field, size = null){
            if(!this.form[field])
                return false;

            if(size && this.form[field].length < size)
                this.form[field] = '';

            this.form[field] = this.form[field].toUpperCase();
        }
    },
    components:{}
}
</script>

